export const getSlugifiedApi = (apiUrl: string, slugs?: Array<string>) => {
  if (!slugs?.length) {
    return apiUrl
  }

  let finalApiUrl = apiUrl

  slugs.map((x, idx) => {
    finalApiUrl = finalApiUrl.replaceAll(`stencil-url-slug${idx}`, x)
    return finalApiUrl
  })

  return finalApiUrl
}
